import { combineReducers, configureStore } from '@reduxjs/toolkit';

import { regionReducer } from '@/Infrastructure/State/Slices/RegionSlice';
import { addressReducer } from '@/modules/address/infrastructure/AddressSlice';
import { buyNowReducer } from '@/modules/buy-now/infrastructure/slices/BuyNowSlice';
import { cartPaymentsReducer } from '@/modules/cart/infrastructure/CartPaymentsRepository/slices/CartPaymentsSlice/CartPaymentsSlice';
import { cartReducer } from '@/modules/cart/infrastructure/CartReduxRepository/slices/CartSlice';
import { tokenUserIdReducer } from '@/modules/log/infraestructure/slices/LogSlices/TokenUserIdSlice';
import { billingReducer } from '@/modules/perseo-billing/store/slices/billing';
import switchesReducer from '@/modules/perseo-billing/store/switches/switches.reducer';
import userReducer from '@/modules/perseo-billing/store/user/user.reducer';
import { getPerseoInitialState } from '@/modules/perseo-billing/utils/window';
import { pickupReducer } from '@/modules/pickup/infrastructure/PickupSlice';
import { shippingMethodsReducer } from '@/modules/shippingMethod/infrastructure/ShippingMethodsReduxRepository/slices/ShippingMethodsSlice';

const rootReducer = combineReducers({
  user: userReducer,
  region: regionReducer,
  address: addressReducer,
  cart: cartReducer,
  pickup: pickupReducer,
  billing: billingReducer,
  switches: switchesReducer,
  cartPayments: cartPaymentsReducer,
  shippingMethods: shippingMethodsReducer,
  tokenUserId: tokenUserIdReducer,
  buyNow: buyNowReducer
});

export const setupStore = (preloadedState?: Partial<RootState>) => {
  return configureStore({
    reducer: rootReducer,
    preloadedState
  });
};

const perseoBillingInitialState = getPerseoInitialState() as Partial<RootState>;
export const store = setupStore(perseoBillingInitialState);

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = typeof store;
export type AppDispatch = typeof store.dispatch;
